<template>
  <div height="100%" :class="'add_navbg add_navbg_' + fairDetail.multi_color_selection">
    <div v-if="template === '2'">
      <div class="yd-accordion">
        <div class="yd-accordion-title" @click="handleClick"><img src="../../assets/image/nav.png" alt=""></div>
        <div style="padding: .24rem;" v-if="visible" class="nav_box" >
          <div v-for="term of termList" :key="term.id">
            <a :href="term.url" class="nav">{{term.name}}</a>
          </div>
        </div>
      </div>
<!--      <yd-accordion ref="ydaccordion" @open="open">-->
<!--        <yd-accordion-item >-->
<!--          <div style="padding: .24rem;" class="nav_box">-->
<!--            <div v-for="term of termList" :key="term.id">-->
<!--              <a :href="term.url" class="nav">{{term.name}}</a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </yd-accordion-item>-->
<!--      </yd-accordion>-->
      <!-- 图片区域 -->
      <div class="warp">
        <img :src="fairDetail.mimg">
      </div>
      <!-- 图片区域结束 -->
    </div>
    <div v-if="template === '1'">
      <yd-flexbox>
        <yd-flexbox-item v-if="0" class="fariinfo">
          <h3>{{fairDetail.fair_name}}</h3>
          <p>{{fairDetail.reserve_time}}至{{fairDetail.end_reserve_time}}</p>
        </yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox>
        <yd-flexbox-item class="bottom">
          <yd-grids-group :rows="3">
            <yd-grids-item
              v-for="term of termList"
              :key="term.id"
              @click.native="activeCheck(term)"
            >
              <img slot="icon" :src="term.img" :onerror="termDefaultImg(term)"/>
              <span slot="text">{{term.name}}</span>
            </yd-grids-item>
          </yd-grids-group>
        </yd-flexbox-item>
      </yd-flexbox>
    </div>

  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      visible: true,
      termList: [],
      fairDetail: [],
      template: '',
      backgroupData: [],
      defaultImg: 'this.src="' + require('../../assets/image/term-default/online.png') + '"',
      defaultImgData: {
        'online': 'this.src="' + require('../../assets/image/term-default/online.png') + '"',
        'hotel': 'this.src="' + require('../../assets/image/term-default/hotel.png') + '"',
        'order': 'this.src="' + require('../../assets/image/term-default/order.png') + '"',
        'voucher': 'this.src="' + require('../../assets/image/term-default/voucher.png') + '"',
        'content': 'this.src="' + require('../../assets/image/term-default/list.png') + '"',
        'lianxi': 'this.src="' + require('../../assets/image/term-default/lianxi.png') + '"',
        'jieji': 'this.src="' + require('../../assets/image/term-default/jieji.png') + '"',
        'zhinan': 'this.src="' + require('../../assets/image/term-default/jieshao.png') + '"',
        'jieshao': 'this.src="' + require('../../assets/image/term-default/jieshao.png') + '"',
        'jiabin': 'this.src="' + require('../../assets/image/term-default/jiabin.png') + '"',
        'list': 'this.src="' + require('../../assets/image/term-default/list.png') + '"',
        'piclist': 'this.src="' + require('../../assets/image/term-default/list.png') + '"'
      },
      params: this.$route.params
    }
  },
  methods: {
    getFairDetail () {
      let data = {id: this.params.id, limit: 20}
      axios
        .post('/fair/fair-detail', data)
        .then(this.getFairDetailSucc)
    },
    handleClick () {
      console.log('hshhahhahah')
      this.visible = !this.visible
    },
    getFairDetailSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.termList = res.data.termList
        this.fairDetail = res.data.fair
        if (this.fairDetail.mimg === '') {
          this.fairDetail.mimg = require('../../assets/image/long_figure.jpg')
        }
        this.template = res.data.fair.template

        // setTimeout(() => {
        //   this.$nextTick(() => {
        //     this.$refs.ydaccordion.show = true
        //     console.log(this.$refs.ydaccordion.open)
        //   })
        // }, 500)
      } else {
        // this.$dialog.alert({mes: '会议不存在'})
      }
    },
    termDefaultImg (term) {
      let img = this.defaultImg
      if (this.defaultImgData[term.ident_m]) {
        img = this.defaultImgData[term.ident_m]
      }
      return img
    },
    activeCheck (term) {
      if (term.seo_description !== null && term.seo_description !== '') {
        this.$dialog.confirm({
          title: '温馨提示',
          mes: term.seo_description,
          opts: () => {
            window.location.href = term.url
          }
        })
      } else {
        window.location.href = term.url
      }
    }
  },
  mounted () {
    this.getFairDetail()
  }
}
</script>

<style lang="stylus" scoped>
  .bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .fariinfo {
    margin: .3rem;
  }

  .fariinfo h3 {
    line-height: 1.5;
    font-size: .45rem;
  }

  .fariinfo p {
    line-height: 2;
    font-size: .3rem;
  }

  .yd-flexview
    max-width: 1920px !important

  .yd-grids-item::after
    display: none

  .yd-grids-item::before
    display: none

  .warp
    width: 100%
    overflow: hidden

  .warp img
    max-width: 100%
    width: 100%

  .yd-accordion
    position: fixed
    background: none
    right: 0
    top: .6rem

  .yd-accordion-title
    cursor pointer
    color #FFFFFF
    position: absolute
    right 0.35rem

  .nav_box
    padding: .2rem .4rem !important
    margin-right: .4rem
    margin-top: .6rem
    background-color: rgba(255, 255, 255, 0.9)
    border-radius: .1rem
    position relative
    width 38%
    float right

  .nav

    color: #333
    font-size .4rem
    line-height: .9rem

  .nav::after
    content: ""
    width: calc(100% + .4rem)
    height: 1px
    background-color: #f2f2f2
    position: absolute
    bottom: -.1rem
    left: -.2rem

  .nav_box > :last-child a::after
    display: none

  .add_navbg .yd-accordion
    position: absolute
    left 0
    right 0
    top 0
    padding-top 0.35rem
    height 1rem

  .add_navbg.add_navbg_red .yd-accordion
    background rgba(188,8,7,0.4)

  .add_navbg.add_navbg_blue .yd-accordion
	  background rgba(36,99,166,0.4)

  .add_navbg.add_navbg_black .yd-accordion
	  background rgba(12,12,12,0.4)

  .yd-accordion-title img
    width .5rem

</style>



// WEBPACK FOOTER //
// src/views/template1/FairDetail.vue